import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.tipoCentroCosto.fields.id'),
  },
  {
    name: 'descripcion',
    label: i18n('entities.tipoCentroCosto.fields.descripcion'),
  },
  {
    name: 'habilitado',
    label: i18n('entities.tipoCentroCosto.fields.habilitado'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'centrosCostosVinculados',
    label: i18n('entities.tipoCentroCosto.fields.centrosCostosVinculados'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.tipoCentroCosto.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.tipoCentroCosto.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
